export default __webpack_public_path__ + "static/media/spain.7f40933b.png";